<template>
  <div class="keywords"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    <template >
      <v-toolbar flat class="rounded-lg">
        <v-toolbar-title  style="margin-left: 20px;"><v-icon class="mx-2">mdi-key-variant</v-icon>Daftar Kata kunci </v-toolbar-title> 
        <v-spacer></v-spacer>
        <v-flex lg3>
          <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
        </v-flex>
          <!--v-dialog-->
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                outlined
                rounded
                small
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                >
                Tambah kata kunci baru
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-select label="Topic" dense outlined :items="topicselect" v-model="topic_id" 
                      item-text="name_topic" 
                      item-value="valuetopic" 
                      value="Enabled"></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="inputedItem.keywordid" label="Keyword ID"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-select label="Keyword Status" dense outlined 
                      :items="keywordstatusselect" 
                      item-text="name" 
                      item-value="value" 
                      v-model="keywordstatus"></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" width="330px"> 
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>

              <v-divider class="mt-4" style=""></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-toolbar>
    </template>
    <v-data-table
      :headers="headers"
      :items="keyword"
      :search="search"
      sort-by="groupkeyword"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mx-2" small  @click="editItem(item.SEQ_ID)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item.SEQ_ID)">
            mdi-delete
          </v-icon>
        </template>
        
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
    </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>

<script>
  import axios from "axios"
import Notification from  '@/components/Notification';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      search: '',
      dialog: false,
      dialogDelete: false,
        topic_id:'',
        keyword_id:'',
        topicselect: [
          {
            valuetopic: '', 
            name_topic: '' 
          }
        ],
        keywordstatus:1,
        keywordstatusselect: [//choice select
            {value: 1, name: "Enabled" },
            {value: 0, name: "Disabled" }
          ],
        page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Keyword Manager',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Keywords',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      headers: [
        { text: 'Group Keyword', value: 'GROUP_KEYWORD' },
        { text: 'Keyword', value: 'KEYWORD_ID' },
        { text: 'Keyword Status', value: 'KEYWORD_STATUS' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'SYS_CREATED' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'SYS_UPDATE' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      keyword: [],
      id_keyword:'',
      editedIndex: -1,
      inputedItem: {
     
      },
      defaultItem: {

      },
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Tambah Kata Kunci' : 'Edit Kata Kunci'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        
        this.tableLoading = true;
        axios.get("keyword",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            this.keyword = response.data.data //untuk table
            // ----- selected group ----
            let result = '';
            let arr_data = [];
            if(response.data.topic.length > 0){
              for (let i = 0; i <  response.data.topic.length; i++) {  
                  if(i == 1){
                    this.topic_id = (response.data.topic[i].SEQ_ID);
                  }
                  result = {
                    valuetopic : response.data.topic[i].SEQ_ID,
                    name_topic : response.data.topic[i].GROUP_NAME
                  };
                  arr_data.push(result);
              }
              this.topicselect= arr_data;
            }
            // ----- end selected group ----

            setTimeout(() =>{
              this.loading = false
            // end loading 
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      
      },
      deleteItem (item) {
        this.id_keyword = item
        this.inputedItem = Object.assign({}, item)
        this.editedIndex = this.keyword.indexOf(item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.keyword.splice(this.editedIndex, 1)
        
        axios({
          method: "delete",
          url: "/keyword/delete",
          data: {
            seq_id: this.id_keyword
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          console.log(response);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.id_keyword = item
        this.editedIndex = 1;
        // alert(item);
        // this.editedIndex = this.keyword.indexOf(item)
        this.inputedItem = Object.assign({}, item)
        axios({
          method: "put",
          url: "/keyword_Id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = response.data;
            this.keywordstatus =dat.KEYWORD_STATUS; 
            this.keyword_id =dat.SEQ_ID; 
            this.topic_id =dat.GROUP_ID; 
            this.inputedItem = {
              keywordid:dat.KEYWORD_ID
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        this.dialog = true
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.keyword[this.editedIndex], this.inputedItem)
          axios.put("/keyword/update", 
            {
              seq_id:this.keyword_id,
              group_id:this.topic_id,
              keyword_id:this.inputedItem.keywordid,
              keywors_status:this.keywordstatus
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            
              this.initialize()
              this.$router.push('/keywords');
              // alert('okk');      
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        } 
        else {
          axios.post("/keyword/insert", 
            {
              group_id:this.topic_id,
              keyword_id:this.inputedItem.keywordid,
              keywors_status:this.keywordstatus,
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              this.$router.push('/keywords');
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          // this.usermanagement.push(this.inputitem)
        this.initialize();
          this.keyword.push(this.inputedItem)
        } this.close()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>